import { forwardRef, StyleProps } from '@bonusly/design-system';

import { ReactionButtonEmpty } from './reaction-button-empty';
import { ReactionButtonSelected } from './reaction-button-selected';
import { useReactionContext } from './reaction-select-context';

export const ReactionsButton = forwardRef<StyleProps, 'button'>(({ ...rest }, ref) => {
	const { selected } = useReactionContext();

	if (selected) {
		return <ReactionButtonSelected reaction={selected} ref={ref} {...rest} />;
	}

	return <ReactionButtonEmpty ref={ref} {...rest} />;
});
